import { ReactNode, useState } from 'react';

type CardShellProps = {
  title: string;
  source?: 'ai' | 'page';   // 谁渲染的：AI 面板 or 页面点击
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  onClick?: () => void;     // 整卡点击（页面层入口用）
  children: ReactNode;
};

export function CardShell({ title, source = 'ai', collapsible = true, defaultCollapsed = false, onClick, children }: CardShellProps) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  return (
    <div
      onClick={onClick}
      style={{
        border: '1px solid #e5e5ea', borderRadius: 12, margin: '8px 0',
        background: '#fff', overflow: 'hidden',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '8px 12px', borderBottom: collapsed ? 'none' : '1px solid #f0f0f0',
        background: '#fafafa', fontSize: 13, fontWeight: 600,
      }}>
        <span>{title}</span>
        <span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{
            fontSize: 10, fontWeight: 400, padding: '1px 6px', borderRadius: 8,
            background: source === 'ai' ? '#eef2ff' : '#f5f5f5',
            color: source === 'ai' ? '#4f46e5' : '#888',
          }}>
            {source === 'ai' ? 'AI' : '页面'}
          </span>
          {collapsible && (
            <button
              onClick={(e) => { e.stopPropagation(); setCollapsed(!collapsed); }}
              style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, color: '#888' }}
            >
              {collapsed ? '展开' : '折叠'}
            </button>
          )}
        </span>
      </div>
      {!collapsed && <div style={{ padding: 10 }}>{children}</div>}
    </div>
  );
}
